var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21C10.7675 19.6753 12.9293 19.658 17 21M12 20V17M2 7L2 13C2 15.2091 3.79086 17 6 17L18 17C20.2091 17 22 15.2091 22 13V7C22 4.79086 20.2091 3 18 3L6 3C3.79086 3 2 4.79086 2 7Z",
    stroke: "#ED7F23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21C10.7675 19.6753 12.9293 19.658 17 21M12 20V17M2 7L2 13C2 15.2091 3.79086 17 6 17L18 17C20.2091 17 22 15.2091 22 13V7C22 4.79086 20.2091 3 18 3L6 3C3.79086 3 2 4.79086 2 7Z",
    stroke: "#ED7F23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L7.83333 7.00003L9.66667 12",
    stroke: "#ED7F23",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1111 7.00003V12",
    stroke: "#ED7F23",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1113 7.00014H13.3336C14.0085 7.00014 14.5558 7.5598 14.5558 8.25013C14.5558 8.94046 14.0085 9.50012 13.3336 9.50012H12.1113",
    stroke: "#ED7F23",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4585 10.7501H9.2085",
    stroke: "#ED7F23",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.00003V12",
    stroke: "#ED7F23",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiPackages);
export default __webpack_public_path__ + "static/media/api-packages.6f1e892ca47edef260c54c947f408a61.svg";
export { ForwardRef as ReactComponent };